<template>
  <v-container fluid>
    <div v-if="carregando">
      <div class="mt-2 text-center" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item" class="mb-2"></v-skeleton-loader>
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </div>
    </div>
		<div v-else>
      <v-row align="center">
        <v-col cols="12" sm="10">
          <div class="text-h1 mb-2">
            Propostas geradas
          </div>
        </v-col>
        <v-col cols="12" sm="2" class="text-right pr-4">
          <v-btn color="primary" link to="/relatorios">
            Voltar
          </v-btn>
        </v-col>
      </v-row>
			<v-tabs
        next-icon="chevron_right"
        prev-icon="chevron_left"
        show-arrows
        class="ui-tabs"
        v-model="tabs">
        <v-tab link to="#listagem">
          <v-icon>clipboard-text</v-icon> Listagem
        </v-tab>
        <v-tab link to="#graficos">
          <v-icon>assessment</v-icon> Gráficos
        </v-tab>
      </v-tabs>
			<v-tabs-items v-model="tabs" class="relatorio_height">
				<v-tab-item class="px-1 pb-1" id="listagem">
          <v-row no-gutters>
            <v-col cols="12" md="12" class="mb-3">
              <v-row class="pl-2 pr-2 mt-2" v-if="totalizadores">
                <v-col cols="12" md="3">
                  <v-card class="py-3 px-4 vcard_area">
                    <v-row>
                      <v-col cols="12" md="7" class="z-over-relatorio">
                        <div class="text-h1 mb-2">{{ totalizadores.total_exibidas }}</div>
                        <div class="text-h2 mb-2">Propostas sendo exibidas</div>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                          <v-icon>description</v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card class="py-3 px-4 vcard_area vcard_area-primary">
                    <v-row>
                      <v-col cols="12" md="12" class="z-over-relatorio">
                        <div class="text-h1 mb-2">{{ retornaTotalStatus(1) }}</div>
                        <div class="text-h2 mb-2">Propostas<br>abertas</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card class="py-3 px-4 vcard_area vcard_area-warning">
                    <v-row>
                      <v-col cols="12" md="12" class="z-over-relatorio">
                        <div class="text-h1 mb-2">{{ retornaTotalStatus(2) }}</div>
                        <div class="text-h2 mb-2">Propostas<br>canceladas</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" md="2">
                  <v-card class="py-3 px-4 vcard_area vcard_area-success">
                    <v-row>
                      <v-col cols="12" md="12" class="z-over-relatorio">
                        <div class="text-h1 mb-2">{{ retornaTotalStatus(3) }}</div>
                        <div class="text-h2 mb-2">Propostas<br>fechadas</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <v-card class="py-3 px-4 vcard_area">
                    <v-row>
                      <v-col cols="12" md="7" class="z-over-relatorio">
                        <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.total_valor)}}</div>
                        <div class="text-h2 mb-2">Valor total em propostas</div>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                          <v-icon>monetization_on</v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-5">
              <v-row align="center" justify="space-between" class="mb-2">
                <v-col cols="12" md="11">
                  <v-row no-gutters align="center">
                    <v-col cols="12" class="pt-0" md="4" :class="!$root.Permissions.integrator() ? 'mb-3' : ''">
                      <VueCtkDateTimePicker
                        position="bottom"
                        v-on:callback="changeDates"
                        v-model="data_entrada"
                        class="date-picker pl-2"
                        locale="pt-BR"
                        :no-header="true"
                        :no-value-to-custom-elem="true"
                        :overlay="true"
                        :range="true"
                        :formatted="'L'"
                        :format="'YYYY-MM-DD'"
                        color="#004A93"
                        :dark="$vuetify.theme.dark"
                        button-color="#004A93"
                        :custom-shortcuts="labels"
                        :no-button="true"
                        :noClearButton="true"
                        :auto-close="true"
                        :loading="loadingSearch"
                        :disabled="loadingSearch"
                        :submit="retornoData(data_entrada)"
                      >
                        <v-btn class="px-2 ui-search_btn w-100" elevation="0" v-ripple="{ class: `success--text` }">
                          <b class="text">
                            Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                          </b>
                        </v-btn>
                      </VueCtkDateTimePicker>
                    </v-col>
                    <v-col cols="12" md="8" class="pt-0" v-if="!$root.Permissions.integrator()"></v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-form @submit.prevent="applyFilter()">
                        <v-text-field
                          class="ml-2"
                          clearable
                          hide-details=""
                          clear-icon="close"
                          v-model="search"
                          outlined
                          label="Busca"
                          @click:clear="limparBusca()"
                        ></v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0" v-if="$root.Permissions.admin()">
                      <v-autocomplete
                        class="ml-2"
                        :menu-props="{ offsetY: true}"
                        v-model="distribuidor"
                        :items="distribuidores"
                        hide-details=""
                        clearable
                        clear-icon="close"
                        label="Distribuidor"
                        append-icon="expand_more"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0" v-if="!$root.Permissions.integrator()">
                      <v-autocomplete
                        class="ml-2"
                        :menu-props="{ offsetY: true}"
                        v-model="integrador"
                        :items="integradores"
                        hide-details=""
                        clearable
                        clear-icon="close"
                        label="Integrador"
                        append-icon="expand_more"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2" v-if="integrador">
                      <v-autocomplete
                        :menu-props="{ offsetY: true}"
                        v-model="etapa"
                        :items="etapas"
                        clearable
                        class="ml-2"
                        clear-icon="close"
                        label="Etapa do funil"
                        hide-details=""
                        append-icon="expand_more"
                        :loading="loadingEtapas"
                        :disabled="loadingEtapas"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        :menu-props="{ offsetY: true}"
                        v-model="status"
                        :items="statuses"
                        clearable
                        class="ml-2"
                        clear-icon="close"
                        label="Status"
                        hide-details=""
                        append-icon="expand_more"
                        :loading="loadingSearch"
                        :disabled="loadingSearch"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2" md="2" class="pl-2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon medium color="primary" v-bind="attrs" v-on="on" @click="alteraOrdem()">
                            {{ ordem === 0 ? 'filter_list_off' : ordem === 1 ? 'arrow_downward' : 'arrow_upward'}}
                          </v-icon>
                        </template>
                        <span class="text-center">
                          Ordenar por status
                          <v-icon small color="primary">
                            {{ ordem === 0 ? 'arrow_downward' : ordem === 1 ? 'arrow_upward' : 'filter_list_off'}}
                          </v-icon>
                          <br>
                          <span v-if="ordem === 0" class="caption text-center w-100">(Aberta > Perdida > Fechada)</span>
                          <span v-if="ordem === 1" class="caption text-center w-100">(Fechada > Perdida > Aberta)</span>
                          <span v-if="ordem === 2" class="caption text-center w-100">(Remover ordenação)</span>
                        </span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="1" class="text-right">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="exportPdf()">
                        <v-icon large color="primary">
                          print
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Imprimir relatório</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-for="item of dados" :key="item.pos_id" class="mb-4">
              <p class="pl-1 mb-0">
                <span
                  class="relatorio-link font-weight-black text-capitalize text-h3"
                  @click="goToContact(item.cliente.uuid_cli_id)"
                >
                  {{ item.cliente.cli_nome }}
                </span> /
                <span
                  class="relatorio-link font-weight-light text-caption"
                  @click="goToOportunidade(item.uuid_opu_id)"
                >
                  Cód. da Oportunidade: {{ item.opu_id }}
                </span>
                <span
                  class="relatorio-link font-weight-light text-caption"
                  @click="goToOportunidade(item.uuid_opu_id, '#propostas-comerciais')"
                >
                  / Cód. da Propostas: {{ item.pos_id }}
                </span>
              </p>
              <v-data-table
                disable-sort
                disable-pagination
                disable-filtering
                hide-default-footer
                :headers="headers"
                :items="[item]"
                :search="search"
                loading-text="Carregando... Por favor aguarde"
                :loading="carregando"
                class="elevation-1 base_table mb-5"
                :header-props="{
                  sortIcon: 'north',
                }"
              >
                <template v-slot:item.pos_status="{ item }">
                  <v-chip small label class="relatorio_chip" :color="colors[item.pos_status]">
                    {{ item.pos_status }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row no-gutters align="center" justify="center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon medium color="primary" v-bind="attrs" v-on="on" @click="exportPdf([item])">
                          print
                        </v-icon>
                      </template>
                      <span>Imprimir proposta</span>
                    </v-tooltip>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
				</v-tab-item>
				<v-tab-item class="px-1 pb-1" id="graficos">
          <graficos-relatorio
            v-if="grafico"
            :loading-search="loadingSearch"
            :grafico="grafico"
            v-on:atualiza-grafico="getGraficos"
          >
          </graficos-relatorio>
				</v-tab-item>
			</v-tabs-items>
		</div>
  </v-container>
</template>
<script>
import Api from '@API'
import GraficosRelatorio from '../GraficosRelatorio.vue'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    GraficosRelatorio,
    VueCtkDateTimePicker
  },
  data () {
    return {
      headers: [
        {
          text: 'ID do Cliente',
          align: 'start',
          value: 'cliente.cli_id'
        },
        { text: 'Cliente', value: 'cliente.cli_nome' },
        { text: 'Telefone', value: 'cliente.cli_telefone' },
        { text: 'Celular', value: 'cliente.cli_celular' },
        { text: 'CEP', value: 'opu_cep' },
        { text: 'Estado', value: 'opu_uf' },
        { text: 'Cidade', value: 'opu_cidade' },
        { text: 'Data', value: 'pos_criado_em' },
        { text: 'Tipo de instalação', value: 'opu_tipo_instalacao' },
        { text: 'Tipo de Estrutura', value: 'opu_tipo_estrutura' },
        { text: 'Potência', value: 'pos_potencia' },
        { text: 'Potência do módulo', value: 'pos_potencia_modulo' },
        { text: 'Etapa', value: 'etapa' },
        { text: 'Status', value: 'pos_status' },
        { text: 'Valor', value: 'pos_total' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      search: '',
      loadingSearch: false,
      de: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().subtract(90, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      statuses: [
        {
          text: 'Aberta',
          color: 'blue',
          value: 1
        },
        {
          text: 'Cancelada',
          color: 'amber accent-4',
          value: 2
        },
        {
          text: 'Fechada',
          color: 'green',
          value: 3
        }
      ],
      colors: {
        Aberta: 'blue',
        Cancelada: 'amber accent-4',
        Fechada: 'green',
        Baixa: 'red',
        Média: 'orange',
        Alta: 'green'
      },
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      funis: [],
      funil: null,
      loading: false,
      loadingEtapas: false,
      etapas: [],
      tiposEstrutura: [],
      status: null,
      distribuidorAnterior: null,
      loadingDistribuidores: false,
      distribuidores: [],
      distribuidor: null,
      loadingIntegradores: false,
      integradores: [],
      integrador: null,
      integradorAnterior: null,
      etapa: null,
      options: {},
      tabs: 0,
      carregando: false,
      relatorio: {},
      dados: [],
      dadosExport: [],
      grafico: null,
      ordem: 0,
      totalizadores: null
    }
  },
  methods: {
    retornaTotalStatus (status) {
      if (this.totalizadores.total_status) {
        if (this.totalizadores.total_status[status]) return this.totalizadores.total_status[status]
      }
      return 0
    },
    alteraOrdem () {
      this.ordem++
      if (this.ordem > 2) this.ordem = 0
      this.applyFilter()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      if (filters.busca) this.search = filters.busca
      if (filters.etapa) this.etapa = filters.etapa
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.status) this.status = Number(filters.status)

      this.loadFunctions()
    },
    async loadFunctions () {
      this.getTiposEstrutura()
      this.getIntegrators(this.distribuidor)
      this.getDistributors()
      this.getGraficos()
      this.getRelatorio()
      await this.getEtapas()
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData (datas) {
      if (datas.start !== this.de || datas.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
        this.etapa = ''
      }

      this.loading = true

      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.etapa ? { etapa: this.etapa } : '',
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.status ? { status: this.status } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }

      if (!this.$root.Permissions.integrator() && this.integrador !== this.integradorAnterior && this.integrador) {
        this.etapa = ''
        await this.getEtapas()
      }
      this.integradorAnterior = this.integrador

      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getRelatorio()
    },
    async getRelatorio () {
      this.carregando = true
      let parametros = `?de=${this.de}&ate=${this.ate}`

      if (this.search) parametros += `&busca=${this.search}`
      if (this.status) parametros += `&status=${this.status}`
      if (this.etapa) parametros += `&etapa=${this.etapa}`
      if (this.distribuidor && !this.integrador) parametros += `&distribuidor=${this.distribuidor}`
      if (this.integrador) parametros += `&integrador=${this.integrador}`
      if (this.ordem === 1) parametros += `&ordem=asc`
      if (this.ordem === 2) parametros += `&ordem=desc`

      await Api.get(`relatorios/propostas-geradas${parametros}`)
        .then(async res => {
          let info = []
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              if (this.etapa) {
                let etapaAtual = this.retornaEtapa(item.oportunidade)
                if (etapaAtual.uuid_fet_id !== this.etapa) return false
              }
              info.push({
                ...item.oportunidade,
                cliente: item.cliente,
                opu_cep: item.oportunidade && item.oportunidade.opu_cep ? this.formataCEP(item.oportunidade.opu_cep) : '',
                pos_criado_em: this.$root.Formatter.formatDate(item.pos_criado_em, 'DD/MM/YYYY'),
                pos_potencia: this.retornaDecimal(item.pos_potencia) + ' kWp',
                pos_potencia_modulo: this.retornaDecimal(item.pos_potencia_modulo) + ' W',
                opu_tipo_instalacao: this.retornaTipoInstalacao(item.oportunidade.opu_tipo_instalacao),
                opu_tipo_estrutura: this.retornaTipoEstrutura(item.oportunidade.opu_tipo_estrutura),
                pos_total: this.retornaValor(item.pos_total),
                pos_status: this.statuses[item.pos_status - 1].text,
                pos_id: item.pos_id,
                uudi_pos_id: item.uudi_pos_id,
                etapa: this.retornaEtapa(item.oportunidade).fet_nome
              })
            })
          }
          await this.getTotalizadores(parametros)
          this.dados = info
          this.carregando = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o relatório!',
            color: 'error'
          })
        })
    },
    getTotalizadores (parametros) {
      Api.get(`relatorios/propostas-geradas-totalizadores${parametros}`)
        .then(res => {
          if (res.data) {
            this.totalizadores = res.data
          } else {
            this.totalizadores = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os totalizadores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaEtapa (oportunidade) {
      if (!oportunidade.etapas || !oportunidade.etapas.length) return null

      let etapaAtual = null
      let funilAtual = 1

      if (oportunidade.opu_status === 3) funilAtual = 2
      oportunidade.etapas.map(etapa => {
        if (etapa.fk_fun_id_funil === funilAtual) etapaAtual = etapa
      })
      return etapaAtual
    },
    retornaDecimal (valor) {
      if (!valor) return '0,00'
      return valor.toString().replace('.', ',')
    },
    retornaTipoInstalacao (tipo) {
      if (!tipo) return null
      let tipoSelecionado = this.tiposInstalacao[tipo - 1]
      return tipoSelecionado ? tipoSelecionado.text : null
    },
    retornaTipoEstrutura (tipoSel) {
      if (!tipoSel) return null
      let tipoSelecionado = this.tiposEstrutura.find(tipo => tipo.tie_id === tipoSel)
      return tipoSelecionado ? tipoSelecionado.tie_nome : null
    },
    formataCEP (cep) {
      if (!cep) return ''
      cep = cep.toString().replace('-', '')
      cep = `${cep.substr(0, 5)}-${cep.substr(5)}`
      return cep
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.tiposEstrutura = res.data
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome
              })
            })
            this.distribuidores = info
          }
        })
    },
    getGraficos (datas = null) {
      let parametros = `?de=${this.de}&ate=${this.ate}`
      if (datas) {
        parametros = `?de=${datas.start}&ate=${datas.end}`
      }
      this.loadingSearch = true
      Api.get(`relatorios/propostas-geradas-grafico${parametros}`)
        .then(res => {
          if (res.data) {
            this.grafico = res.data
          }
          this.loadingSearch = false
        })
    },
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações') cabecalhos.push(header)
      })
      return cabecalhos
    },
    async exportPdf (dados = null) {
      let de = this.$root.Formatter.formatDate(this.de, 'DD/MM/YYYY')
      let ate = this.$root.Formatter.formatDate(this.ate, 'DD/MM/YYYY')
      let header = this.headers
      header[0].width = '5%'

      let url = `relatorios/propostas-geradas?de=${this.de}&ate=${this.ate}`

      if (this.search) url += `&busca=${this.search}`
      if (this.status) url += `&status=${this.status}`
      if (this.etapa) url += `&etapa=${this.etapa}`
      if (this.distribuidor && !this.integrador) url += `&distribuidor=${this.distribuidor}`
      if (this.integrador) url += `&integrador=${this.integrador}`
      if (this.ordem === 1) url += `&ordem=asc`
      if (this.ordem === 2) url += `&ordem=desc`

      this.$root.Export.PDF(this, {
        titulo: 'Propostas geradas',
        subtitulo: `Período ${de} até ${ate}`,
        landscape: true,
        isRelatorio: true,
        tabela: {
          headers: header,
          dados,
          uuid: dados && dados.length ? dados[0].uuid_opu_id + dados[0].pos_id : null,
          tiposEstrutura: this.tiposEstrutura,
          url
        }
      })
    },
    retornaValor (valor) {
      if (!valor) return 'R$ 0,00'
      return this.$root.Formatter.floatToMoney(valor)
    },
    async getEtapas () {
      if (!this.$root.Permissions.integrator() && !this.integrador) return false

      let parametros = ''
      if (!this.$root.Permissions.integrator()) {
        parametros = `?integrador=${this.integrador}`
      }

      const endpoint = `funis/etapas${parametros}`
      await Api.get(endpoint)
        .then(async res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_fet_id,
                text: item.fet_nome
              })
            })
            this.etapas = info
          }
        })
        .catch(err => {
          console.log(err)
          this.loadingEtapas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
        })
    },
    goToContact (uuid) {
      this.$router.push({ name: 'Contato', params: { uuid } }).catch(() => {})
    },
    goToOportunidade (uuid, tab = '') {
      this.$router.push(
        {
          name: 'OportunidadeInterna',
          params: { uuid: uuid },
          hash: tab
        }
      ).catch(() => {})
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>>.v-tabs-items {
  min-height: inherit!important;
}
.relatorio {
  &_chip {
    width: 80px;
    justify-content: center;
  }
  &_height {
    min-height: 80vh!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/comerciais/RelatorioPropostasGeradas.vue